import React, { FunctionComponent } from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { ILessonStudentFeedback } from '../../../store/V2/LessonStudentFeedbacksSlice';
import AddStudentFeedbackForm from './AddStudentFeedbackForm';
import { IFeedbackTutor } from './helper';

interface AddStudentFeedbackModalProps {
  open: boolean;
  onClose: () => void;
  sectionId: string;
  feedback?: ILessonStudentFeedback;
  tutors?: IFeedbackTutor[];
  onFeedbackAdded?: (feedbackData: ILessonStudentFeedback[]) => void;
  onFeedbackUpdated?: (
    id: string,
    feedbackData: ILessonStudentFeedback
  ) => void;
}

const AddStudentFeedbackModal: FunctionComponent<AddStudentFeedbackModalProps> = ({
  open,
  tutors = [],
  sectionId,
  feedback,
  onClose,
  onFeedbackAdded,
  onFeedbackUpdated,
}) => {
  const mode = feedback ? 'edit' : 'new';

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { borderRadius: '20px', maxWidth: '520px' },
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: { xs: '15px', sm: '30px' },
          color: '#000000',
          fontWeight: 600,
          fontSize: '16px',
        }}
      >
        {mode === 'edit' ? 'Edit feedback' : 'New feedback'}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: { xs: '7px', sm: '22px' },
          top: { xs: '7px', sm: '22px' },
        }}
      >
        <CloseIcon sx={{ color: '#000000' }} />
      </IconButton>
      <DialogContent sx={{ p: { xs: '0 15px', sm: '0 30px' } }}>
        <Box sx={{ pb: { xs: '15px', sm: '30px' } }}>
          <AddStudentFeedbackForm
            sectionId={sectionId}
            tutors={tutors}
            feedback={feedback}
            onFeedbackAdded={
              onFeedbackAdded
                ? (feedbackData) => {
                    onFeedbackAdded(feedbackData);
                    onClose();
                  }
                : undefined
            }
            onFeedbackUpdated={
              onFeedbackUpdated
                ? (id, feedbackData) => {
                    onFeedbackUpdated(id, feedbackData);
                  }
                : undefined
            }
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AddStudentFeedbackModal;
